import { transformExtent } from "ol/proj";

const transform = (extent: number[]) => {
	return transformExtent(extent, "EPSG:4326", "EPSG:3857");
};

export const DEFAULT_MAP_CENTER: [number, number] = [47.7, 29.3];
export const MAX_OPACITY_GEOTIFF: number = 0.6;
export const GEOTIFF_IMAGE_SPEED = 250;
export const MAP_EXTEND = transform([10, 9, 86, 46]);
export const MAP_CARD_EXTEND = transform([39.73, 22.17, 56.23, 36.59]);
